<template>
  <div class="upload-file">
    <input ref="uploadEl" type="file" class="hidden" :id="`upload-file-${fid}`" multiple />
    <div>
      <ul class="mt-2">
        <li class="mb-2 last:mb-0 relative" v-for="(file, index) in value" :key="file.url">
          <file-item class="upload-file-item"  :file="file" @remove="removeFile(index)" :view="view"/>
        </li>
      </ul>
    </div>
    <div class="before-file-upload mt-2" v-if="showUploadBtn">
      <label :for="`upload-file-${fid}`" class="block py-2 cursor-pointer">
        <span>上传附件（{{ text }}{{ uploadFileMaxSize }}M以内）</span>
      </label>
    </div>
  </div>
</template>

<script>
import { FileErrorCode, upload, uploadFile } from 'dygc'
import { Message, Loading } from 'dygc-ui'
import FileItem from '@/questions/components/FileItem'

let _fid = 0
export default {
  name: 'UploadFiles',
  components: { FileItem },
  props: {
    uploadFileMaxSize:{
      type: Number,
      default: 30,
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    allowTypes: {
      type: Array,
      default: () => []
    },
    checkFileType: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: () => []
    },
    view:{
      type:Boolean,
      default:false
    }
  },
  inject:{
    view:{
      default: false
    }
  },
  data() {
    return {
      fid: _fid++
    }
  },
  computed: {
    showUploadBtn() {
      let max = this.max
      return max > this.value.length
    },
    text() {
      let max = this.max
      let min = this.min || -1
      if (max < 0) {
        return ''
      }
      if (min <= 0) {
        return '上限' + max + '个，每个'
      } else {
        return '至少上传' + min + '个附件，' + '上限' + max + '个，每个'
      }
    }
  },
  methods: {
    removeFile(index) {
      let value = this.value.slice()
      value.splice(index, 1)
      this.$emit('input', value)
    },
    uploadFile(){
      console.log("文件上传")
      uploadFile({
        maxSize: this.uploadFileMaxSize,
        unit: 'MB',
        allowTypes: this.checkFileType ? this.allowTypes : [],
        multiple: true,
        success: files => {
          if (files.length > this.max) {
            Message.warning(`最多上传${this.max}个文件`)
            return
          }

          const load = Loading.service({
            text: '正在上传',
            background: 'rgba(0,0,0,0.65)'
          })
          const promises = []

          for (let i = 0; i < files.length; i++) {
            let file = files[i]
            let fd = new FormData()
            fd.append('file', file)
            promises.push(upload(fd))
          }
          Promise.all(promises)
              .then(res => {
                let value = this.value.slice()
                res.forEach(item => {
                  value.push({
                    name: item.data.url,
                    url: item.data.url
                  })
                })
                this.$emit('input', value)
                load.close()
              })
              .catch(err => {
                load.close()
              })
        },
        error: err => {
          if (err.code === FileErrorCode.NO_ALLOW_TYPE) {
            Message({ type: 'warning', message: `文件类型错误，仅允许上传${this.allowTypes.join('、')}格式文件` })
          } else {
            Message({ type: 'warning', message: err.msg })
          }
        }
      })
    },
    init() {
      uploadFile({
        maxSize: this.uploadFileMaxSize,
        unit: 'MB',
        allowTypes: this.checkFileType ? this.allowTypes : [],
        el: this.$refs.uploadEl,
        multiple: true,
        success: files => {
          if (files.length > this.max) {
            Message.warning(`最多上传${this.max}个文件`)
            return
          }

          const load = Loading.service({
            text: '正在上传',
            background: 'rgba(0,0,0,0.65)'
          })
          const promises = []

          for (let i = 0; i < files.length; i++) {
            let file = files[i]
            let fd = new FormData()
            fd.append('file', file)
            promises.push(upload(fd))
          }
          Promise.all(promises)
            .then(res => {
              let value = this.value.slice()
              res.forEach(item => {
                value.push({
                  name: item.data.url,
                  url: item.data.url
                })
              })
              this.$emit('input', value)
              load.close()
            })
            .catch(err => {
              load.close()
            })
        },
        error: err => {
          if (err.code === FileErrorCode.NO_ALLOW_TYPE) {
            Message({ type: 'warning', message: `文件类型错误，仅允许上传${this.allowTypes.join('、')}格式文件` })
          } else {
            Message({ type: 'warning', message: err.msg })
          }
        }
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>
